import React from "react"
import PropTypes from "prop-types"
// import styled from "styled-components"
import Widget from "../layout/widget/Widget"
import Grid from "../charts/nine-box-grid/Grid"
import NineBoxGridSummaryShape from "../../state/shapes/NineBoxGridSummaryShape"
import NineBoxGridDrillDownBoxShape from "../../state/shapes/NineBoxGridDrilldownBoxShape"

function NineBoxGridLarge({
  exportEndpoint,
  appliedFilters,
  summaryData,
  drilldownData,
  dashboard,
  subtitleKey
}) {
  const identifier="large-nine-box-grid"
  const titleKey="Widgets.NineBoxGrid.Title"
  return (
    <Widget
      id={identifier}
      columns={3}
      titleKey={titleKey}
      helpKey="Widgets.LargeNineBoxGrid.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
    >
      <Grid summary={summaryData} drilldown={drilldownData} dashboard={dashboard} widgetIdentifier={identifier} titleKey={titleKey}/>
    </Widget>
  )
}

NineBoxGridLarge.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  summaryData: PropTypes.arrayOf(PropTypes.shape(NineBoxGridSummaryShape)).isRequired,
  drilldownData: PropTypes.shape(NineBoxGridDrillDownBoxShape),
  exportEndpoint: PropTypes.string.isRequired,
  dashboard: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string
}

NineBoxGridLarge.defaultProps = {
  drilldownData: null
}

export default NineBoxGridLarge



// WEBPACK FOOTER //
// ./src/components/widgets/NineBoxGridLarge.jsx